export default "__VITE_ASSET__DsWaHKth__"